// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__SZVwf","goBack":"Detail_goBack__t-P9H"};